import { request } from "@/network/request";

export function get_down_url() {
  return request({
    method: 'get',
    url: 'https://support.wingstory.xyz/get_url/',
  })
}